export default __webpack_public_path__ + "static/media/statement-thumbnail-no-img.63e23af1.svg";